import {
    LOGIN_FROM_TOKEN_ERROR,
    LOGIN_SUCCESS,
    LOGOUT,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.auth.accessData, action = {type: ''}) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        case LOGIN_FROM_TOKEN_ERROR:
        case LOGOUT:
            return initialState.auth.accessData;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/authReducer/accessDataReducer.js